import { v1ApiClient } from '@/services';
import type { PathParams } from '@/shared/api/generated';

type HelpscoutPath = '/v1/workspaces/{workspace_id}/helpscout';

/**
 * Helpscout 연동 해제
 */
export const deleteHelpscoutInfo = ({
  workspace_id,
}: PathParams<HelpscoutPath, 'delete'>): Promise<void> =>
  v1ApiClient
    .delete(`/workspaces/${workspace_id}/helpscout`)
    .then((res) => res.data);
